import { useEffect, useRef } from "react";
import { io } from "socket.io-client";
import mioSound     from "../assets/mio.mp3";
import timeoutSound from "../assets/timeout.mp3";

export default function SoundOverlay() {
  const socketRef = useRef(null);

  useEffect(() => {
    const s = io("", { path: "/socket.io", transports: ["polling", "websocket"], withCredentials: true });
    socketRef.current = s;

    s.on("connect",    () => s.emit("join_display"));
    s.on("reconnect",  () => s.emit("join_display"));

    const play = (src) => { try { new Audio(src).play(); } catch {} };

    s.on("mio:sound",     ()  => play(mioSound));
    s.on("sound:test",    ({ type }) => play(type === "timeout" ? timeoutSound : mioSound));
    s.on("subasta:ended", (p) => { if (p?.reason === "timeout") play(timeoutSound); });

    return () => { s.disconnect(); socketRef.current = null; };
  }, []);

  return <div style={{ background: "transparent" }} />;
}
